<div id="footer" *ngIf="(siteMenu$ | async) as siteMenu">
    <footer class="footer"
        [ngStyle]="{ 'color': backgroundColor == '#fff' || backgroundColor == '#ffffff' || backgroundColor == '#FFF' || backgroundColor == '#FFFFFF' ? '#000' : textColor,'background-color': backgroundColor,'background-image': backgroundColor && backgroundColor.includes('#')?'none':backgroundColor }">
        <div class="container pb-20 pt-20">
            <div fxLayout="column wrap" fxLayout.gt-sm="row wrap" fxLayoutAlign="center center">
                <div [fxFlex]="fullWidth?'100%':'50%'" [ngClass]="{'text-center': fullWidth}" fxFlexAlign="start"
                    class="footer-logo">
                    <div class="footer-logo">
                        <span *ngFor="let item of siteMenu">
                            <a [ngStyle]="{ 'color': item.type=='button'?'#fff':textColor }" (click)="navigateTo(item.link)" *ngIf="!item.option" [routerLink]="['/']"
                                [fragment]="item.newUrl" mat-button> {{ item.title }}</a>
                            <a [ngStyle]="{ 'color': item.type=='button'?'#fff':textColor }" (click)="navigateTo(item.link)" *ngIf="item.option && item.link.length<5"
                                [routerLink]="['/']" [fragment]="item.newUrl" mat-button> {{ item.title }}</a>
                            <a *ngIf="item.option && item.link.length>5" rel="noopener" [target]="item.option"
                                [href]="item.link | safeUrl" mat-button
                                [ngStyle]="{ 'color': item.type=='button'?'#fff':textColor }"> {{ item.title }}</a>
                        </span>
                        <!-- <img alt="angular" class="footer-logo" src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/angular-white-transparent.svg"> -->
                    </div>
                </div>
                <!-- <div class="footer-version"><span class="version">Current Version:
          8.0.0</span></div> -->
                <div fxFlexAlign="end" class="footer-social">
                    <span>
                        <a *ngIf="termsofService" [href]="'https://'+siteUrl+'/tos' | safeUrl" rel="noopener"
                            target="_blank">Terms & Conditions</a>
                        &nbsp; &nbsp; &nbsp; &nbsp;
                        <a *ngIf="privacyPolicy" rel="noopener" [href]="'https://'+siteUrl+'/privacy-policy' | safeUrl"
                            target="_blank">Privacy Policy</a>
                        &nbsp; &nbsp; &nbsp; &nbsp;
                    </span>
                    <a *ngIf="socialNetworks.facebook" [href]="socialNetworks.facebook | safeUrl" target="_blank"
                        rel="noopener noreferrer" class="footer-nw__icon">
                        <img src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/social/facebook-16.svg"
                            alt="facebook">
                    </a>

                    <a *ngIf="socialNetworks.twitter" [href]="socialNetworks.twitter | safeUrl" target="_blank"
                        rel="noopener noreferrer" class="footer-nw__icon">

                        <img src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/social/twitter-16.svg"
                            alt="twitter">
                    </a>

                    <a *ngIf="socialNetworks.instagram" [href]="socialNetworks.instagram | safeUrl" target="_blank"
                        rel="noopener noreferrer" class="footer-nw__icon">
                        <img src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/social/instagram-16.svg"
                            alt="instagram">
                    </a>

                    <a *ngIf="socialNetworks.youtube" [href]="socialNetworks.youtube | safeUrl" target="_blank"
                        rel="noopener noreferrer" class="footer-nw__icon">
                        <img src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/social/youtube-16.svg"
                            alt="youtube">
                    </a>

                    <a *ngIf="socialNetworks.pinterest" [href]="socialNetworks.pinterest" target="_blank"
                        rel="noopener noreferrer" class="footer-nw__icon">
                        <img src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/social/pinterest-16.svg"
                            alt="pinterest">
                    </a>

                    <a *ngIf="socialNetworks.vkontakte" href="https://www.vk.com/socialbakers | safeUrl" target="_blank"
                        rel="noopener noreferrer" class="footer-nw__icon">
                        <img src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/social/vkontakte-16.svg"
                            alt="vkontakte">
                    </a>

                    <a *ngIf="socialNetworks.linkedin" [href]="socialNetworks.linkedin | safeUrl" target="_blank"
                        rel="noopener noreferrer" class="footer-nw__icon">
                        <img src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/social/linkedin-16.svg"
                            alt="linkedin">
                    </a>

                    <a *ngIf="socialNetworks.snapchat" [href]="socialNetworks.snapchat | safeUrl" target="_blank"
                        rel="noopener noreferrer" class="footer-nw__icon">
                        <img src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/social/snapchat-16.svg"
                            alt="snapchat">
                    </a>

                </div>
            </div>
            <div class="text-center copy-right"[ngStyle]="{ 'color': textColor }">
                <span [ngStyle]="{ 'color': textColor }">© {{year}} {{siteName}}. All Rights Reserved</span>
            </div>
        </div>
    </footer>
</div>